import {generateRequest} from 'fallco-frontend-framework/src/js/classes/HttpManager/api_utilities.js';

const END_POINT = 'download';

const downloadFile = (settings, params, callback) => generateRequest(END_POINT, settings, {data: params}, callback);

const apiEndpoint = {
  downloadFile
}

export default apiEndpoint;